
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Globe } from 'lucide-react';
import { useTranslation } from '@/lib/i18n';
import useI18nStore, { type Language } from '@/lib/i18n';

export function LanguageSelector() {
  const { language, setLanguage } = useI18nStore();
  const { t } = useTranslation();

  const handleLanguageChange = (value: string) => {
    setLanguage(value as Language);
  };

  return (
    <Select value={language} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-32 bg-white/10 border-white/20 text-white hover:bg-white/20">
        <Globe className="h-4 w-4 mr-2" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="vi">{t('header.vietnamese')}</SelectItem>
        <SelectItem value="en">{t('header.english')}</SelectItem>
      </SelectContent>
    </Select>
  );
}
